<template>
  <v-row :class="`alert-wrapper pa-3 alert-wrapper--${alertType}`" no-gutters>
    <v-col class="shrink d-flex justify-center" :class="`align-${align}`">
      <v-icon :class="`icon icon--${alertType}`">{{ icon }}</v-icon>
    </v-col>
    <v-col class="d-flex align-center">
      <span class="w-full">
        <slot></slot>
      </span>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import {AlertType} from '@/models/enums/AlertType';
import {computed, PropType} from 'vue';

const props = defineProps({
  alertType: {
    type: String as PropType<AlertType>,
    default: AlertType.WARNING,
  },
  align: {
    type: String as PropType<'start' | 'center' | 'end'>,
    default: 'center',
  },
});
const icon = computed<string>(() => {
  switch (props.alertType) {
  case AlertType.WARNING:
    return 'mdi-alert';
  case AlertType.INFO:
    return 'mdi-information';
  case AlertType.SUCCESS:
    return 'mdi-check';
  case AlertType.ERROR:
    return 'mdi-alert-octagon';
  default:
    return 'mdi-alert';
  }
});
</script>

<style scoped lang="scss">
.alert-wrapper {
  border-radius: 4px;
  border: 1px solid;
  line-height: 24px;
  &--warning {
    background-color: #FFCC1A0F;
    border-color: var(--token-warning-base);
  }

  &--info {
    background-color: #0A73EB0F;
    border-color: var(--v-info-base);
  }

  &--success {
    background-color: #23CD300F;
    border-color: var(--token-success-border);
  }

  &--error {
    background-color: #FA72680F;
    border-color: var(--token-error-border);
  }
}

.icon {
  margin-right: 12px;

  &--warning {
    color: var(--token-warning-base);
  }

  &--info {
    color: var(--v-info-base);
  }

  &--success {
    color: var(--token-success-text);
  }

  &--error {
    color: var(--token-error-text);
  }
}
</style>
